/**
 * Environment variable validation and access
 * Ensures all required environment variables are present at build time
 */

const requiredEnvVars = {
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_PUBLISHABLE_KEY: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  VITE_SUPABASE_PROJECT_ID: import.meta.env.VITE_SUPABASE_PROJECT_ID,
} as const;

/**
 * Validates that all required environment variables are present
 */
function validateEnv(): void {
  const missing: string[] = [];

  for (const [key, value] of Object.entries(requiredEnvVars)) {
    if (!value) {
      missing.push(key);
    }
  }

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(", ")}\n` +
        `Please check your .env file and ensure all variables are set.`
    );
  }
}

// Validate on module load (only in production builds)
if (import.meta.env.PROD) {
  validateEnv();
}

export const env = {
  supabase: {
    url: requiredEnvVars.VITE_SUPABASE_URL!,
    publishableKey: requiredEnvVars.VITE_SUPABASE_PUBLISHABLE_KEY!,
    projectId: requiredEnvVars.VITE_SUPABASE_PROJECT_ID!,
  },
} as const;
